import { useTranslation } from 'react-i18next';

export default function ClimateTipsSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-[#F0EFED] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col gap-12">
          <div className="flex flex-col items-center text-center gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">{t('threeStep.climate.label')}</span>
              <div className="w-8 h-px bg-[#7B1113]" />
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-[1.15]">
              {t('threeStep.climate.heading')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex flex-col gap-5 p-8 rounded-2xl bg-white">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#D4A017]/10 flex items-center justify-center">
                  <i className="ri-sun-line text-[#D4A017] text-xl"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-[#2A2A2A]">{t('threeStep.climate.hot.title')}</span>
                  <span className="text-[10px] text-[#8A8A8A] font-light">{t('threeStep.climate.hot.subtitle')}</span>
                </div>
              </div>

              <ul className="flex flex-col gap-3">
                {[t('threeStep.climate.hot.tip1'), t('threeStep.climate.hot.tip2'), t('threeStep.climate.hot.tip3'), t('threeStep.climate.hot.tip4'), t('threeStep.climate.hot.tip5')].map((tip) => (
                  <li key={tip} className="flex items-start gap-2 text-xs text-[#8A8A8A] font-light leading-[1.7]">
                    <i className="ri-check-line text-[#D4A017] text-sm mt-0.5 flex-shrink-0"></i>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-col gap-5 p-8 rounded-2xl bg-white">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#1B3A5C]/10 flex items-center justify-center">
                  <i className="ri-moon-line text-[#1B3A5C] text-xl"></i>
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-[#2A2A2A]">{t('threeStep.climate.cool.title')}</span>
                  <span className="text-[10px] text-[#8A8A8A] font-light">{t('threeStep.climate.cool.subtitle')}</span>
                </div>
              </div>

              <ul className="flex flex-col gap-3">
                {[t('threeStep.climate.cool.tip1'), t('threeStep.climate.cool.tip2'), t('threeStep.climate.cool.tip3'), t('threeStep.climate.cool.tip4'), t('threeStep.climate.cool.tip5')].map((tip) => (
                  <li key={tip} className="flex items-start gap-2 text-xs text-[#8A8A8A] font-light leading-[1.7]">
                    <i className="ri-check-line text-[#1B3A5C] text-sm mt-0.5 flex-shrink-0"></i>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}